import React, { useState, useEffect } from 'react';
import './SchnellanfragenChips.css';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface Schnellanfrage {
  id: number;
  rolle: string;
  text: string;
  position: number;
  aktiv: boolean;
}

interface SchnellanfragenChipsProps {
  onScenarioClick: (text: string) => void;
  authToken: string;
}

const SchnellanfragenChips: React.FC<SchnellanfragenChipsProps> = ({ onScenarioClick, authToken }) => {
  const [anfragen, setAnfragen] = useState<Schnellanfrage[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!authToken) return;
    fetch(`${API_URL}/api/schnellanfragen/meine`, {
      headers: { Authorization: `Bearer ${authToken}` },
    })
      .then(r => r.ok ? r.json() : [])
      .then(data => setAnfragen(Array.isArray(data) ? data : []))
      .catch(() => setAnfragen([]));
  }, [authToken]);

  if (anfragen.length === 0) return null;

  return (
    <div className="schnellanfragen-bar">
      <button className="schnellanfragen-toggle" onClick={() => setOpen(v => !v)}>
        {open ? '▲ Schnellanfragen' : `▼ Schnellanfragen (${anfragen.length})`}
      </button>
      <div className={`schnellanfragen-chips${open ? ' open' : ''}`}>
        {anfragen.map(a => (
          <button
            key={a.id}
            className="schnellanfrage-chip"
            onClick={() => onScenarioClick(a.text)}
          >
            {a.text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SchnellanfragenChips;
